var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callout",class:_vm.size + ' ' + _vm.color},[_c('i',{staticClass:"callout-icon",class:_vm.icon}),_c('div',{staticClass:"callout-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }